import script from "./AuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AuButton.vue?vue&type=script&setup=true&lang=js"

import "./AuButton.vue?vue&type=style&index=0&id=4a7ca614&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7ca614"]])

export default __exports__